import type { Attachment } from "../../Album/types/attachment.types.ts"
import type { FilesFilters } from "../types/files-filters.types.ts"
import {
  classifyFileFormat,
  type FileFormatCategory
} from "./classify-file-format.ts"

interface AttachmentFilterContext {
  /** Only set for the "include subfolders" case — every id in the subtree.
   *  A plain exact-folder filter is applied server-side and needs no
   *  client recheck here. */
  folderIds?: Set<string> | null
}

// `model_type`, `document_type`, `status`, the exact-folder case and the
// date range are real server-side query params now (see
// `attachmentFilterParams` in useFilesData.ts). `album` and `owner` are
// matched elsewhere (needing state — the album's member ids, the owner
// closure — that this pure function has no access to). This covers the
// dimensions an Attachment can be excluded from outright, or matched
// against its own fields alone.
export const attachmentMatchesFilters = (
  attachment: Attachment,
  filters: FilesFilters,
  { folderIds }: AttachmentFilterContext = {}
): boolean => {
  // Related Record stays a `document`-only concept — an Attachment carries
  // no such field (EAD-615 gave it Document Type/Status, not this).
  if (filters.related_record_type && filters.related_record_id) return false

  if (filters.file_type) {
    const category: FileFormatCategory = classifyFileFormat({
      name: attachment.original_filename,
      mimeType: attachment.mime_type
    })
    if (category !== filters.file_type) return false
  }

  if (folderIds && (!attachment.folder || !folderIds.has(attachment.folder)))
    return false

  return true
}
